/**
 * Legal/policy pages content.
 *
 * The original Vediluxe wording (in ./policies.legacy.ts) is live. The
 * shorter wording PhonePe asked for during merchant verification is parked
 * in ./policies.phonepe.ts — swap the spread below if they ever re-review.
 */
import { LEGACY_POLICIES } from './policies.legacy';

export type PolicyBlock =
  | { type: 'heading'; text: string }
  | { type: 'text'; text: string }
  | { type: 'list'; items: string[] };

export interface PolicyDoc {
  slug: string;
  title: string;
  updated: string;
  /** Structured content (preferred) */
  blocks?: PolicyBlock[];
  /** Legacy plain-paragraph content */
  paragraphs?: string[];
}

const CONTACT_US: PolicyDoc = {
  slug: 'contact-us',
  title: 'Contact Us',
  updated: 'July 2026',
  blocks: [
    { type: 'text', text: 'We are happy to help with orders, returns, product questions or anything else.' },
    {
      type: 'list',
      items: [
        'Email — support@vediluxe.com (we aim to respond within 2 business days).',
        'Mobile — +91 9990145810.',
        'Support hours — Monday to Saturday, 10:00–18:00 IST.',
        'Registered office — Vediluxe, J-281/6, Kartar Nagar, Delhi, India.'
      ]
    },
    {
      type: 'text',
      text: 'For order-related queries, please include your Order ID (shown in your confirmation email and under My Account → Orders) so we can assist you faster.'
    }
  ]
};

export const POLICIES: PolicyDoc[] = [...LEGACY_POLICIES, CONTACT_US];

export const getPolicy = (slug: string): PolicyDoc | undefined =>
  POLICIES.find((p) => p.slug === slug);
